import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}dedemonstrant/`;

const title = "Holy Road - The Protester";
const description = "His ‘nom de guerre’ is Tito. Every week, he sets out to protest against the Israeli army. It’s David versus Goliath, he says. But he has no choice.";
const featuredImage = `${imageFolder}dedemonstrant/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}dedemonstrant`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/248500680",
        text: "What does life look like? See here a day in the life of Tito, a Palestinian protester."
    },
    {
        type: "Paragraph",
        text: "If you ask Tito where he originates from, he answers: I am from Salama. Salama, however, no longer exists on the map. It was a village just outside Jaffa, the ancient Arabian harbor town now one of the suburbs Tel Aviv, Israel. Salama was ethnically cleansed by Zionist militias and literally wiped off the map. Only the ‘Shalma Road’ is a reminder of the former Arabian occupancy. About 7,000 inhabitants had to flee their houses and ended up in camps. They were placed among others, in the al Am’ari refugee camp near Ramallah, in the West Bank. The family of Tito was placed there as well."
    },
    {
        type: "Paragraph",
        text: "Almost seventy years later, Tito still lives here. He is prohibited from staying in Tel-Aviv, even if it is only one day. As with his ancestors, he too strives to fight against the Jews – though not so much the Zionist militias, but against the Israeli army. According to international law, Palestinian refugees from around 1948 and their descendants – the estimated amount is 5 million – retain the right to return to where they originated, in present day Israel. However this now not only applies to Israel but to Tito and his family in the West Bank as this is now an occupied and colonized area."
    },
    {
        type: "Paragraph",
        text: "Tito and his fellow protestors, with their stones and Molotov cocktails, do not stand much of a chance against the Israeli army, who carry M16’s and tear gas bombs. Israel is punishing these forms of resistance more severely these days. Palestinian stone-throwers risk a prison sentence of twenty years if they get caught. Tito is now thirty-two. Friends keep asking him when he will stop protesting and start a family. The resistance is in my blood, is Tito’s response. He has to strive for his country. There is no alternative for him."
    },
]


// WEBPACK FOOTER //
// ./src/data/stories/story5.js